import React from 'react';
import { Link } from 'react-router';

import map from 'lodash/map';

import Campaign from './components/campaign';

import { renderDefaultTD } from '../../../shared/new-table/renderers';
import { enum as popupTypes } from '../../../../../../../enums/popup-types';
import { enum as popupEvents } from '../../../../../../../enums/popup-events';

function renderCampaigns(index, row) {
	const value = row[index];

	return (
		<ul className='popups-campaign-list'>
			{value.map((campaignId) => (
				<Campaign
					campaignId={campaignId}
					key={campaignId}
				/>
			))}
		</ul>
	);
}

function renderContent(index, row) {
	const value = row[index];

	switch (row.type) {
		case popupTypes.simple:
			return map(value, ({ image, link }, lang) => (
				<div className='banners-lang-list' key={lang}>
					<div className={`flag-icon flag-icon-${lang}`} />
					<div className='banners-lang-list-data'>
						<div>image: <a href={image} target='_blank'>{image}</a></div>
						{link && (
							<div>link: <a href={link} target='_blank'>{link}</a></div>
						)}
					</div>
				</div>
			));
		case popupTypes.custom:
			return (
				<div style={{ textAlign: 'left' }}>custom content id: {value.id}</div>
			);
	}
}

function renderEventCount(index, row, { event }) {
	const { [index]: value, id } = row;

	return value ? (
		<Link
			to={`/statistics/general?popup=${id}&event=${event}`}
			target='_blank'
		>
			{value}
		</Link>
	) : (
		<span>
			{value}
		</span>
	);
}

function renderActions(index, row, { removePopupById }) {
	return (
		<div className='action-list'>
			<Link
				className='banners-edit-icon'
				to={`/popups/main/${row.id}/editor`}
			/>
			<a
				className='remove-icon'
				onClick={() => removePopupById(row.id)}
			/>
		</div>
	);
}

function createRenderTD(removePopupById) {
	return function ({ index, column }, props) {
		if (index === 'campaign_ids') {
			return (
				<td className={column.className} key={index}>
					{renderCampaigns(index, props.row)}
				</td>
			);
		}
		if (index === 'content') {
			return (
				<td className={column.className} key={index}>
					{renderContent(index, props.row)}
				</td>
			);
		}
		if (index === 'views') {
			return (
				<td className={column.className} key={index}>
					{renderEventCount(index, props.row, { event: popupEvents.view })}
				</td>
			);
		}
		if (index === 'clicks') {
			return (
				<td className={column.className} key={index}>
					{renderEventCount(index, props.row, { event: popupEvents.click })}
				</td>
			);
		}
		if (index === 'actions') {
			return (
				<td className={column.className} key={index}>
					{renderActions(index, props.row, { removePopupById })}
				</td>
			);
		}

		return renderDefaultTD({ index, column }, props);
	};
}

export default createRenderTD;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/popup/list/create-render-td.js